import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IChatbotPublic } from "../../../Components/ChatbotPublic/IChatbotPublic";

export const ReadChatbotPublicSlicer = createSlice({
  name: "ReadChatbotPublicSlicer",
  initialState: {} as IReduxState<IChatbotPublic>,
  reducers: {
    ReadchatbotPublic: (state, _: PayloadAction<IChatbotPublic>) => {
      state.isLoading = true;
    },
    successReadChatbotPublic: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureReadChatbotPublic: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearReadChatbotPublicStatus: (state) => {
      state.data = {};
    },
  },
});

export const {
  ReadchatbotPublic,
  successReadChatbotPublic,
  failureReadChatbotPublic,
  clearReadChatbotPublicStatus,
} = ReadChatbotPublicSlicer.actions;

export default ReadChatbotPublicSlicer.reducer;
